<template>
    <div class="lib__text-center faq col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <p class="lib__text-weight-600 lib__text-center faq-text">{{ $t('new-connection-cmh.stillHaveQuestions') }}</p>
        <a :href="url" @click="onClick()" target="_blank" class="lib__link__mobile--underline faq-anchor-link">{{ $t('new-connection-cmh.visitTheFaq') }}</a>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
    name: 'faq-display'
})
export default class FaqDisplay extends Vue {

  public url = "https://www.ores.be/faq/fr"
  
  @Emit('link-click')
  public onClick() {
    return this.url
  }
}
</script>

<style>

.faq {
  padding-top: 50px;
  padding-bottom: 50px;
}

@media screen and (min-width: 577px) {
  .faq {
    font-family: 'Open Sans';
    letter-spacing: 0;
    line-height: 20px;
  }
  .faq-text {
    color: #0c0033;
    font-size: 20px;
    margin-bottom: 5px;
  }
  .faq-anchor-link {
    font-size: 16px;
    margin-top: -8px;
  }
}

@media screen and (max-width: 576px) {
  .faq {
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 20px;
  }
  .faq-text {
    color: #0c0033;
    font-size: 16px;
    margin-bottom: 0px;
  }
  .faq-anchor-link {
    font-size: 14px;
    margin-top: -8px;
  }
}

</style>
